import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Dropdown
} from 'semantic-ui-react'

const CardSelectDateTimeOperationUX = (props: any) => {
    return(
      <div>
        <div
          id="CardSelectDateTimeOperationUX-div-1"
          style={{display: "flex" , marginBottom: "10px"}}>

          <div
            id="CardSelectDateTimeOperationUX-div-4"
            style={{marginRight: "10px"}}>

            <div
              id="CardSelectDateTimeOperationUX-div-10">
              {props.doctorLabel}
            </div>
            <Dropdown
              className="inline-label"
              clearable={true}
              disabled={props.disabledDoctorOptions}
              id="CardSelectDateTimeOperationUX-Dropdown-7"
              onChange={props.handleChangeOption("doctor")}
              options={props.operationDoctorOptions}
              search={true}
              selection={true}
              value={props.operationDoctor}>
            </Dropdown>
          </div>
          <div
            id="CardSelectDateTimeOperationUX-div-5"
            style={{marginRight: "10px"}}>

            <div
              id="CardSelectDateTimeOperationUX-div-11">
              {props.anesthesiaLabel}
            </div>
            <Dropdown
              className="inline-label"
              clearable={true}
              disabled={props.disabledAnesthesiaOptions || false}
              id="CardSelectDateTimeOperationUX-Dropdown-8"
              onChange={props.handleChangeOption("anesthesiologist")}
              options={props.ansDoctorOptions}
              search={true}
              selection={true}
              value={props.ansDoctor}>
            </Dropdown>
          </div>
          <div
            id="CardSelectDateTimeOperationUX-div-6"
            style={{marginRight: "10px"}}>

            <div
              id="CardSelectDateTimeOperationUX-div-12">
              {props.operatingRoomLabel}
            </div>
            <div
              id="CardSelectDateTimeOperationUX-div-13">
              {props.operatingRoomOptions}
            </div>
          </div>
          <div
            id="CardSelectDateTimeOperationUX-div-14"
            style={{marginRight: "10px"}}>

            <div
              id="CardSelectDateTimeOperationUX-div-16">
              {"\u00a0"}
            </div>
            <div
              id="CardSelectDateTimeOperationUX-div-15"
              style={{ display: "flex", color: "rgb(6, 108, 187, 0.8)", border: "1px solid rgb(6, 108, 187, 0.8)", borderRadius: "5px", padding: "2px 8px", marginTop: "1rem",fontSize: "0.95rem", minWidth: "max-content"}}>
              {}
              <div
                id="CardSelectDateTimeOperationUX-div-17"
                style={{ fontWeight: "bold", marginRight: "10px" }}>
                {`Case: ${props.operatingCase || ""}`}
              </div>
              <div
                id="CardSelectDateTimeOperationUX-div-18">
                {props.orOrderType || ""}
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardSelectDateTimeOperationUX-div-2">
          {props.selectCalendar}
        </div>
      </div>
    )
}

CardSelectDateTimeOperationUX.displayName = "CardSelectDateTimeOperationUX";
export default React.memo(CardSelectDateTimeOperationUX)

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 17:16:16 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\" , marginBottom: \"10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.selectCalendar"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-2"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Dropdown",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledDoctorOptions"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-Dropdown-7"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeOption(\"doctor\")"
        },
        "options": {
          "type": "code",
          "value": "props.operationDoctorOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.operationDoctor"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAnesthesiaOptions || false"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-Dropdown-8"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeOption(\"anesthesiologist\")"
        },
        "options": {
          "type": "code",
          "value": "props.ansDoctorOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.ansDoctor"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorLabel"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-10"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.anesthesiaLabel"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-11"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingRoomLabel"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-12"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.operatingRoomOptions"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", color: \"rgb(6, 108, 187, 0.8)\", border: \"1px solid rgb(6, 108, 187, 0.8)\", borderRadius: \"5px\", padding: \"2px 8px\", marginTop: \"1rem\",fontSize: \"0.95rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-16"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "`Case: ${props.operatingCase || \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", marginRight: \"10px\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "code",
          "value": "props.orOrderType || \"\""
        },
        "id": {
          "type": "value",
          "value": "CardSelectDateTimeOperationUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardSelectDateTimeOperationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
